(() => {
  const init = () => document.querySelectorAll('[data-gob-catalog-viewer]').forEach(board => {
    if (board.dataset.ready) return;
    board.dataset.ready = 'true';
    let request = 0;
    board.querySelectorAll('[data-bestseller-view]').forEach(button => button.addEventListener('click', async () => {
      const next = ++request;
      const view = button.dataset.bestsellerView;
      const panel = [...board.querySelectorAll('[data-bestseller-angle]')].find(item => item.dataset.bestsellerAngle === view);
      if (!panel) return;
      try { await panel.querySelector('img').decode(); } catch { return; }
      if (next !== request) return;
      board.querySelectorAll('[data-bestseller-angle]').forEach(item => { item.hidden = item !== panel; });
      board.querySelectorAll('[data-bestseller-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      board.dataset.view = view;
      const status = board.querySelector('[data-gob-catalog-status]');
      if (status) status.textContent = button.textContent + '. ' + board.dataset.coverage;
    }));
  });
  const initVariantVideos = () => document.querySelectorAll('[data-gob-forty-story]').forEach(root => {
    if (root.dataset.gobFortyVideoReady) return;
    const watch = root.querySelector('[data-bestseller-watch]');
    const included = root.querySelector('[data-gob-included-inline]');
    if (!watch || !included) return;
    let variants;
    try { variants = JSON.parse(included.querySelector('[data-gob-included-variants]').textContent); } catch { return; }
    if (!Array.isArray(variants) || !variants.some(item => Object.prototype.hasOwnProperty.call(item, 'video'))) return;
    root.dataset.gobFortyVideoReady = 'true';
    const productRoot = document.querySelector('[data-gob-daylight]');
    const select = productRoot?.querySelector('[data-product-select]');
    const defaultVideo = watch.dataset.videoUrl;
    const update = id => {
      const variant = variants.find(item => String(item.id) === String(id));
      const source = variant && (Object.prototype.hasOwnProperty.call(variant, 'video') ? variant.video : defaultVideo);
      let video = '';
      try {
        const url = new URL(source);
        const key = url.hostname === 'youtu.be' ? url.pathname.slice(1) : url.pathname.startsWith('/embed/') ? url.pathname.split('/')[2] : url.searchParams.get('v');
        if (url.protocol === 'https:' && ['youtube.com', 'www.youtube.com', 'youtu.be', 'www.youtube-nocookie.com'].includes(url.hostname) && /^[a-zA-Z0-9_-]{11}$/.test(key || '')) video = url.href;
      } catch {}
      watch.hidden = !video;
      watch.disabled = !video;
      if (video) watch.dataset.videoUrl = video;
      else delete watch.dataset.videoUrl;
      const dialog = root.querySelector('[data-bestseller-video-dialog]');
      if (!video && dialog?.open) dialog.close();
    };
    update(select?.value || included.querySelector('[data-gob-included-version-id][aria-pressed="true"]')?.dataset.gobIncludedVersionId || variants[0]?.id);
    included.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => update(button.dataset.gobIncludedVersionId)));
    select?.addEventListener('change', () => update(select.value));
    document.addEventListener('variant:change', event => {
      const variant = event.detail?.variant;
      if (variant && variants.some(item => String(item.id) === String(variant.id))) update(variant.id);
    });
  });
  // GOB_DEFENDER_COLOR_CONTROLLER_START
  const validateDefenderColorConfig = config => {
    const fail = message => { throw Error('Invalid Defender color configuration: ' + message); };
    const expectedColors = ['blue', 'purple', 'cool-white', 'cyan', 'yellow-green', 'teal', 'red', 'green'];
    const expectedLabels = ['Blue', 'Purple', 'Cool white', 'Cyan', 'Yellow-green', 'Teal', 'Red', 'Green'];
    const expectedMap = { '46529465745741': 'classic', '46529465811277': 'remote', '46529465844045': 'sound' };
    if (config?.version !== 1 || !Array.isArray(config.colors) || config.colors.length !== 8) fail('version or colors');
    if (JSON.stringify(config.colors.map(item => item.token)) !== JSON.stringify(expectedColors)) fail('accepted color order');
    if (JSON.stringify(config.colors.map(item => item.label)) !== JSON.stringify(expectedLabels)) fail('accepted color labels');
    if (!expectedColors.includes(config.defaultColor)) fail('default color');
    if (!config.familyMap || Object.keys(config.familyMap).length !== 3 || Object.entries(expectedMap).some(([id, family]) => config.familyMap[id] !== family)) fail('exact purchase map');
    if (!config.states || typeof config.states !== 'object' || Object.keys(config.states).length !== 34) fail('state count');
    const expected = [], photos = new Set(), urls = new Set();
    for (const view of ['front', 'back']) {
      expected.push('classic:' + view);
      for (const family of ['remote', 'sound']) for (const color of expectedColors) expected.push(family + ':' + view + ':' + color);
    }
    for (const key of expected) {
      const row = config.states[key];
      if (!row || typeof row !== 'object' || Array.isArray(row)) fail('missing ' + key);
      const [family, view, color] = key.split(':');
      if (family === 'sound' && view === 'back') {
        if (row.alias !== 'remote:back:' + color || row.url || row.photo) fail('rear alias ' + key);
        continue;
      }
      if (row.alias || row.photo !== key.replaceAll(':', '-')) fail('source identity ' + key);
      let url;
      try { url = new URL(row.url); } catch { fail('source URL ' + key); }
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || !url.pathname.startsWith('/s/files/1/0022/7573/7711/')) fail('source host ' + key);
      if (photos.has(row.photo) || urls.has(row.url)) fail('duplicate physical source ' + key);
      photos.add(row.photo); urls.add(row.url);
    }
    if (photos.size !== 26 || Object.keys(config.states).some(key => !expected.includes(key))) fail('physical source count');
    return config;
  };
  const resolveDefenderState = (config, family, view, color) => {
    if (!['classic', 'remote', 'sound'].includes(family) || !['front', 'back'].includes(view) || !config.colors.some(item => item.token === color)) return null;
    const key = family + ':' + view + (family === 'classic' ? '' : ':' + color);
    const row = config.states[key];
    if (!row) return null;
    if (family === 'sound' && view === 'back' && row.alias !== 'remote:back:' + color) return null;
    let source = row, sourceKey = key;
    if (row.alias) {
      if (family !== 'sound' || view !== 'back' || row.alias !== 'remote:back:' + color) return null;
      sourceKey = row.alias;
      source = config.states[sourceKey];
      if (!source || source.alias) return null;
    }
    if (!source.url || source.photo !== sourceKey.replaceAll(':', '-')) return null;
    return { key, family, view, color: family === 'classic' ? '' : color, sourceKey, photo: source.photo, url: source.url };
  };
  const initDefenderColorComparison = (board, root) => {
    if (root?.dataset.set !== '10317' || !board.hasAttribute('data-gob-forty-color-compare')) return null;
    if (board.dataset.fortyCompareReady) return null;
    const frames = [...board.querySelectorAll('[data-gob-defender-frame]')];
    const levels = [...board.querySelectorAll('[data-gob-defender-family]')];
    const views = [...board.querySelectorAll('[data-gob-defender-view]')];
    const colors = [...board.querySelectorAll('[data-gob-defender-color]')];
    const palette = board.querySelector('[data-gob-defender-colors]');
    const live = board.querySelector('[data-gob-forty-status]');
    const hideFrames = () => frames.forEach(frame => {
      frame.hidden = true;
      frame.classList.remove('is-active');
      frame.setAttribute('aria-hidden', 'true');
    });
    const unavailable = () => { if (live) live.textContent = board.dataset.unavailable || ''; };
    let config;
    try {
      config = validateDefenderColorConfig(JSON.parse(board.querySelector('[data-gob-forty-color-map]').textContent));
      if (frames.length !== 26 || new Set(frames.map(frame => frame.dataset.gobDefenderFrame)).size !== 26) throw Error('Physical frame count');
      if (!palette || levels.length !== 3 || views.length !== 2 || colors.length !== 8) throw Error('Control count');
      if (['classic', 'remote', 'sound'].some(family => !levels.some(button => button.dataset.gobDefenderFamily === family))) throw Error('Family controls');
      if (['front', 'back'].some(view => !views.some(button => button.dataset.gobDefenderView === view))) throw Error('View controls');
      if (config.colors.some(color => !colors.some(button => button.dataset.gobDefenderColor === color.token))) throw Error('Color controls');
      for (const row of Object.values(config.states)) if (!row.alias) {
        const frame = frames.find(item => item.dataset.gobDefenderFrame === row.photo);
        if (!frame || frame.querySelector('img')?.getAttribute('src') !== row.url) throw Error('Exact source mismatch');
      }
    } catch {
      hideFrames();
      if (palette) palette.hidden = true;
      board.removeAttribute('aria-busy');
      unavailable();
      return null;
    }
    board.dataset.fortyCompareReady = 'true';
    const included = root.querySelector('[data-gob-included-inline]');
    const select = document.querySelector('[data-gob-daylight]')?.querySelector('[data-product-select]');
    const initialId = select?.value || included?.querySelector('[data-gob-included-version-id][aria-pressed="true"]')?.dataset.gobIncludedVersionId;
    let requestedFamily = config.familyMap[String(initialId)] || board.dataset.requestedFamily;
    if (!['classic', 'remote', 'sound'].includes(requestedFamily)) requestedFamily = 'classic';
    let requestedView = ['front', 'back'].includes(board.dataset.view) ? board.dataset.view : 'front';
    let requestedColor = config.colors.some(color => color.token === board.dataset.color) ? board.dataset.color : config.defaultColor;
    let requestToken = 0, renderedState = null;
    const updateControls = () => {
      levels.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobDefenderFamily === requestedFamily)));
      views.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobDefenderView === requestedView)));
      colors.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobDefenderColor === requestedColor)));
      palette.hidden = requestedFamily === 'classic';
      if (palette.hidden && palette.contains(document.activeElement)) levels.find(button => button.dataset.gobDefenderFamily === requestedFamily)?.focus();
    };
    // Decode each exact source once; two background workers prepare hidden views.
    const decoded = new Set(), pending = new Map();
    const loadFrame = (state, priority = 'high') => {
      const frame = frames.find(item => item.dataset.gobDefenderFrame === state.photo);
      const image = frame?.querySelector('img');
      if (!image || image.getAttribute('src') !== state.url) return Promise.reject(Error('Defender source mismatch'));
      if (decoded.has(state.photo)) return Promise.resolve(frame);
      if (priority === 'high' || !pending.has(state.photo)) image.fetchPriority = priority;
      if (pending.has(state.photo)) return pending.get(state.photo);
      image.loading = 'eager';
      const task = image.decode().catch(() => {
        if (!image.complete || !image.naturalWidth) throw Error('Defender image unavailable');
      }).then(() => { decoded.add(state.photo); return frame; }).finally(() => pending.delete(state.photo));
      pending.set(state.photo, task);
      return task;
    };
    const clearRendered = () => {
      hideFrames(); renderedState = null;
      delete board.dataset.renderedFamily;
      delete board.dataset.renderedView;
      delete board.dataset.renderedColor;
    };
    const commit = (state, frame) => {
      hideFrames();
      frame.hidden = false;
      frame.classList.add('is-active');
      frame.setAttribute('aria-hidden', 'false');
      renderedState = state;
      board.dataset.view = state.view;
      board.dataset.color = requestedColor;
      board.dataset.renderedFamily = state.family;
      board.dataset.renderedView = state.view;
      board.dataset.renderedColor = state.color;
      const familyLabel = levels.find(button => button.dataset.gobDefenderFamily === state.family)?.textContent.trim();
      const viewLabel = views.find(button => button.dataset.gobDefenderView === state.view)?.textContent.trim();
      const colorLabel = config.colors.find(item => item.token === state.color)?.label;
      if (live) live.textContent = [familyLabel, viewLabel, colorLabel, frame.getAttribute('title')].filter(Boolean).join('. ');
      board.removeAttribute('aria-busy');
    };
    async function render(family = requestedFamily, view = requestedView, color = requestedColor) {
      const state = resolveDefenderState(config, family, view, color);
      if (!state) return false;
      requestedFamily = family; requestedView = view; requestedColor = color;
      board.dataset.requestedFamily = family;
      board.dataset.requestedView = view;
      board.dataset.requestedColor = color;
      const token = ++requestToken;
      updateControls();
      const frame = frames.find(item => item.dataset.gobDefenderFrame === state.photo);
      if (decoded.has(state.photo)) { commit(state, frame); return true; }
      // Never retain Sound-only lamps while a different purchase family loads.
      if (!renderedState || renderedState.family !== family) clearRendered();
      board.setAttribute('aria-busy', 'true');
      try { await loadFrame(state); }
      catch {
        if (token === requestToken) { clearRendered(); board.removeAttribute('aria-busy'); unavailable(); }
        return false;
      }
      if (token !== requestToken) return false;
      commit(state, frame);
      return true;
    }
    const prewarm = () => {
      if (typeof navigator !== 'undefined' && (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || ''))) return;
      const queue = [], seen = new Set();
      const add = (family, view, color) => {
        const state = resolveDefenderState(config, family, view, color);
        if (state && !seen.has(state.photo)) { seen.add(state.photo); queue.push(state); }
      };
      add(requestedFamily, requestedView === 'front' ? 'back' : 'front', requestedColor);
      for (const family of ['classic', 'remote', 'sound']) add(family, requestedView, requestedColor);
      for (const color of config.colors) for (const family of [requestedFamily, 'classic', 'remote', 'sound']) for (const view of ['front', 'back']) add(family, view, color.token);
      const worker = async () => { while (queue.length) { try { await loadFrame(queue.shift(), 'low'); } catch {} } };
      void worker(); void worker();
    };
    const sync = id => {
      const family = config.familyMap[String(id)];
      return family ? render(family) : false;
    };
    levels.forEach(button => button.addEventListener('click', () => render(button.dataset.gobDefenderFamily)));
    views.forEach(button => button.addEventListener('click', () => render(requestedFamily, button.dataset.gobDefenderView)));
    colors.forEach(button => button.addEventListener('click', () => {
      if (requestedFamily !== 'classic') render(requestedFamily, requestedView, button.dataset.gobDefenderColor);
    }));
    included?.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => sync(button.dataset.gobIncludedVersionId)));
    select?.addEventListener('change', () => sync(select.value));
    document.addEventListener('variant:change', event => sync(event.detail?.variant?.id));
    render().then(success => { if (success) prewarm(); });
    return { render, sync, state: () => ({ requestedFamily, requestedView, requestedColor, renderedState, requestToken }) };
  };
  // GOB_DEFENDER_COLOR_CONTROLLER_END
  const initFortyComparisons = () => document.querySelectorAll('[data-gob-forty-compare]').forEach(board => {
    const defenderRoot = board.closest('[data-gob-forty-story]');
    if (defenderRoot?.dataset.set === '10317' && board.hasAttribute('data-gob-forty-color-compare')) {
      initDefenderColorComparison(board, defenderRoot);
      return;
    }
    if (board.dataset.fortyCompareReady) return;
    board.dataset.fortyCompareReady = 'true';
    const root = board.closest('[data-gob-forty-story]');
    const panels = [...board.querySelectorAll('[data-bestseller-angle]')];
    const levels = [...board.querySelectorAll('[data-gob-forty-family]')];
    const views = [...board.querySelectorAll('[data-bestseller-view]')];
    const controls = board.querySelector('.gob-compare-levels');
    const note = board.querySelector('[data-gob-forty-photo-note]');
    const disclosure = board.querySelector('[data-gob-forty-disclosure]');
    let familyMap = {};
    try { familyMap = JSON.parse(board.querySelector('[data-gob-forty-family-map]').textContent); } catch {}
    let requestedFamily = board.dataset.requestedFamily;
    let requestedView = board.dataset.view;
    let request = 0;
    async function render(family = requestedFamily, view = requestedView) {
      if (!levels.some(button => button.dataset.gobFortyFamily === family)) return;
      let panel = panels.find(item => item.dataset.bestsellerAngle === view);
      if (panel?.dataset.gobOnlyFamily && panel.dataset.gobOnlyFamily !== family) {
        panel = panels.find(item => !item.dataset.gobOnlyFamily || item.dataset.gobOnlyFamily === family);
        view = panel?.dataset.bestsellerAngle;
      }
      if (!panel) return;
      requestedFamily = family;
      requestedView = view;
      board.dataset.requestedFamily = family;
      const fixed = panel.hasAttribute('data-gob-fixed-note');
      const image = fixed ? panel.querySelector('img') : panel.querySelector('[data-gob-photo-family="' + family + '"]');
      if (!image) return;
      const next = ++request;
      board.setAttribute('aria-busy', 'true');
      try {
        await image.decode().catch(() => {
          if (!image.complete || !image.naturalWidth) throw Error('Comparison image unavailable');
        });
      } catch {
        if (next === request) board.removeAttribute('aria-busy');
        return;
      }
      if (next !== request) return;
      panels.forEach(item => {
        item.hidden = item !== panel;
        item.querySelectorAll('img').forEach(photo => {
          const active = item === panel && photo === image;
          photo.classList.toggle('is-active', active);
          photo.setAttribute('aria-hidden', String(!active));
        });
      });
      board.dataset.view = view;
      board.dataset.renderedFamily = fixed ? 'fixed' : family;
      controls.hidden = fixed;
      levels.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.gobFortyFamily === family)));
      views.forEach(button => {
        button.hidden = Boolean(button.dataset.gobOnlyFamily && button.dataset.gobOnlyFamily !== family);
        button.setAttribute('aria-pressed', String(button.dataset.bestsellerView === view));
      });
      if (views.some(button => button.hasAttribute('data-gob-only-family'))) {
        board.querySelector('.gob-compare-views').style.setProperty('--gob-views', String(views.filter(button => !button.hidden).length));
      }
      note.textContent = fixed ? panel.dataset.gobFixedNote : image.dataset.gobPhotoCaption;
      const text = fixed ? '' : panel.dataset.gobDisclosure || '';
      disclosure.textContent = text;
      disclosure.hidden = !text;
      board.removeAttribute('aria-busy');
    }
    levels.forEach(button => button.addEventListener('click', () => render(button.dataset.gobFortyFamily)));
    views.forEach(button => button.addEventListener('click', () => render(requestedFamily, button.dataset.bestsellerView)));
    const included = root.querySelector('[data-gob-included-inline]');
    const productRoot = document.querySelector('[data-gob-daylight]');
    const select = productRoot?.querySelector('[data-product-select]');
    const sync = id => { if (familyMap[String(id)]) render(familyMap[String(id)]); };
    included?.querySelectorAll('[data-gob-included-version-id]').forEach(button => button.addEventListener('click', () => sync(button.dataset.gobIncludedVersionId)));
    select?.addEventListener('change', () => sync(select.value));
    document.addEventListener('variant:change', event => sync(event.detail?.variant?.id));
    const selected = select?.value || included?.querySelector('[data-gob-included-version-id][aria-pressed="true"]')?.dataset.gobIncludedVersionId;
    if (selected && familyMap[String(selected)]) requestedFamily = familyMap[String(selected)];
    render();
  });

  const start = () => { init(); initVariantVideos(); initFortyComparisons(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
